import React from "react";
import { Link } from "react-router-dom";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";

const Footer = () => {
  return (
    <footer className="footer-wrapper">
      <div className="footer-bg-grid" />
      <div className="footer-inner">
        {/* Hospital Branding & Contacts */}
        <div className="footer-column branding-col">
          <div className="footer-logo-card">
            <img
              src="/assets/images/Swarup Logo (1).png"
              alt="Swarup Hospital"
              className="footer-logo-img"
            />
          </div>
          <p className="footer-tagline">
            Providing advanced, compassionate care for a healthier tomorrow.
          </p>

          <div className="footer-contacts">
            <div className="footer-contact-item">
              <FiMapPin className="footer-icon" />
              <span>
                154, Azad Galli, Dudhali, Near KMC College, Kolhapur,
                Maharashtra, India.
              </span>
            </div>
            <div className="footer-contact-item">
              <FiPhone className="footer-icon" />
              <span>
                General: <a href="tel:+919373674641">+91 9373674641</a>
              </span>
            </div>
            <div className="footer-contact-item">
              <FiPhone className="footer-icon red-call" />
              <span className="emergency-call">
                Emergency: <a href="tel:108">108</a> (24/7)
              </span>
            </div>
            <div className="footer-contact-item">
              <FiMail className="footer-icon" />
              <span>
                Email:{" "}
                <a href="mailto:care@swaruphospital.com">
                  swaruphospital154@gmail.com
                </a>
              </span>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h4 className="footer-subtitle">Quick Links</h4>
          <div className="footer-links-list">
            <Link to="/" className="footer-link">
              Home
            </Link>
            <Link to="/services" className="footer-link">
              Services & Specialties
            </Link>
            <Link to="/doctors" className="footer-link">
              Find a Doctor
            </Link>
            <Link to="/patients" className="footer-link">
              Patients & Visitors
            </Link>
            <Link to="/appointments" className="footer-link">
              Book Appointment
            </Link>
            <Link to="/contact" className="footer-link">
              Locations & Contact
            </Link>
            <Link to="/faq" className="footer-link">
              FAQs
            </Link>
          </div>
        </div>

        {/* Hospital Timings */}
        <div className="footer-column">
          <h4 className="footer-subtitle">Hospital Hours</h4>
          <div className="footer-hours">
            <div className="hours-row">
              <span className="hours-label">Emergency Unit:</span>
              <span className="hours-value highlight-green">
                24/7 Available
              </span>
            </div>
            <div className="hours-row">
              <span className="hours-label">OPD Consultations:</span>
              <span className="hours-value">Mon - Sat: 9 AM - 8 PM</span>
            </div>
            <div className="hours-row">
              <span className="hours-label">Pharmacy Counter:</span>
              <span className="hours-value highlight-green">24 Hours Open</span>
            </div>
            <div className="hours-row">
              <span className="hours-label">Visiting Wards:</span>
              <span className="hours-value">Daily: 4 PM - 7 PM</span>
            </div>
          </div>
        </div>

        {/* Social Connections */}
        <div className="footer-column connection-col">
          <h4 className="footer-subtitle">Stay Connected</h4>
          <p className="footer-text">
            Follow our social handles for regular wellness advice and updates
            from our experts.
          </p>

          <div className="footer-social-row">
            <a
              href="https://www.facebook.com/swarupmultispeciality/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn facebook"
              aria-label="Facebook"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://www.instagram.com/swarupmultispeciality_hospital/"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn instagram"
              aria-label="Instagram"
            >
              <FaInstagram />
            </a>
            <a
              href="https://wa.me/919373674641"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon-btn whatsapp"
              aria-label="WhatsApp"
            >
              <FaWhatsapp />
            </a>
          </div>
        </div>
      </div>

      {/* Footer Bottom Block */}
      <div className="footer-bottom-wrapper">
        <div className="footer-bottom">
          <div className="footer-copyright-column">
            <p className="footer-copyright">
              © {new Date().getFullYear()} Swarup Multi-Speciality Hospital. All
              rights reserved.
            </p>
          </div>
          <div className="footer-bottom-links">
            <p className="footer-author">
              Designed and Developed by{" "}
              <a
                href="https://sahyadritech.in/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>Sahyadri Tech</strong>
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
